/**
 * Created by B032151 on 10/24/2017.
 */
import _ from "underscore";
import { ServerAPI } from "../actions/serverAPI";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { userStore } from "../stores/user";
import { formbScrubber } from "../util/formbScrubber";
import { storeUtils } from "./util";
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = "change";

var _serverGuidCalculationResult = null;
var _tempStore = null;
var _previousGuidsCalculated = null;
var _schematicAvailableTrackNames = [];
var _schematicSelectedTrackNames = [];
var _showDefaultTracks = false;
var _isOverride = false;
var _defaultTrackNames = [];
var _useFormGuids = false; //This should only be set to true for opening requests
var _form = null;
var _fromMp = null;
var _fromMpSfx = null;
var _toMp = null;
var _toMpSfx = null;
let _mpEntryChange = false;
var _tracksLoading = false;
var _errors = [];
var _trackHasError = false;

function getAvailableTracks() {
  var trackList = _schematicAvailableTrackNames;

  if (_isOverride) {
    _showDefaultTracks = true;
  }

  if (_showDefaultTracks) {
    trackList = _.uniq(
      _.union(_schematicAvailableTrackNames, _defaultTrackNames),
      false,
      function (e) {
        return e.toLowerCase();
      }
    );
  }

  return trackList.map(function (tr) {
    return { name: tr, checked: false };
  });
}

function removeTrack(trackName) {
  var index = _schematicSelectedTrackNames.indexOf(trackName);
  if (index > -1) {
    _schematicSelectedTrackNames.splice(index, 1);
  }
}

var dispatchToken = dispatcher.register(function (action) {
  switch (action.type) {
    case ActionTypes.SERVER_CALCULATING_GUIDS:
      _tracksLoading = true;
      _serverGuidCalculationResult = null;
      _schematicAvailableTrackNames = [];
      // _schematicSelectedTrackNames = [];
      _showDefaultTracks = false;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SERVER_CALCULATED_GUIDS:
      _tracksLoading = false;
      _errors = [];
      let staleRequest = false;
      _mpEntryChange = false;

      if (
        _serverGuidCalculationResult !== null &&
        _serverGuidCalculationResult !== undefined
      ) {
        staleRequest =
          Number(action.data.actionTime) <
          Number(_serverGuidCalculationResult.actionTime);
      }

      if (staleRequest) {
        console.log("Got a calculate track result that is stale");
        //No-op this is a stale request and should be ignored
      } else {
        if (_tempStore != null) {
          _previousGuidsCalculated = _tempStore;
        }

        _serverGuidCalculationResult = action.data;
        _tempStore = action.data;

        if (_previousGuidsCalculated != null) {
          var previousTrackDefinition =
            _previousGuidsCalculated.trackDefinitions;
          var currentTrackDefintion =
            _serverGuidCalculationResult.trackDefinitions;

          var previousObj = {};

          previousTrackDefinition.forEach(function (item) {
            var guidsList = [];
            item.hostGuids.forEach(function (it) {
              guidsList.push(it.tmdsUid);
            });
            item.innerGuids.forEach(function (it) {
              guidsList.push(it.tmdsUid);
            });
            guidsList = guidsList.sort(function (a, b) {
              return a < b;
            });
            previousObj[item.name] = guidsList;
          });
          var isChanged = false;
          currentTrackDefintion.forEach(function (item) {
            var guidsList = [];
            item.hostGuids.forEach(function (it) {
              guidsList.push(it.tmdsUid);
            });
            item.innerGuids.forEach(function (it) {
              guidsList.push(it.tmdsUid);
            });
            guidsList = guidsList.sort(function (a, b) {
              return a < b;
            });

            var previousGuidList = previousObj[item.name];

            if (previousGuidList) {
              if (previousGuidList.length !== guidsList.length) {
                removeTrack(item.name);
                isChanged = true;
                return;
              } else {
                previousGuidList.forEach(function (it) {
                  if (guidsList.indexOf(it) === -1) {
                    removeTrack(item.name);
                    isChanged = true;
                    return;
                  }
                });
              }
            }
          });

          if (isChanged) {
            currentTrackDefintion.forEach(function (item) {
              removeTrack(item.name);
            });
          }

          _previousGuidsCalculated = null;
        }

        _schematicAvailableTrackNames = _serverGuidCalculationResult.trackNames;
        if (action.selectAllTracks) {
          _schematicSelectedTrackNames = _schematicAvailableTrackNames;
        } else {
          var validTracks = [];
          _schematicSelectedTrackNames.forEach(function (t) {
            if (_schematicAvailableTrackNames.indexOf(t) > -1)
              validTracks.push(t);
          });

          _schematicSelectedTrackNames = validTracks;
        }
        // _showDefaultTracks = _serverGuidCalculationResult.showDefaultTracks; //For now we are not showing default tracks based on track calculation
        _showDefaultTracks = false;
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.SERVER_GUID_ERROR:
      _tracksLoading = false;
      _trackHasError = true;
      if (
        !(_isOverride && action.message.indexOf("not found in TMDS graph") > -1)
      ) {
        _errors = [];
        _errors.push({
          field: "Schematic",
          message: action.message,
          type: "error",
        });
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SCHEMATIC_UPDATE_COMPLETE:
      if (action.clearSelectedTracks) {
        _serverGuidCalculationResult = null;
        _schematicSelectedTrackNames = [];
        _schematicAvailableTrackNames = [];
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.TRACK_SELECTION_CHANGED:
      _useFormGuids = false; //If they make change to the track we no longer use the form guids on a request
      if (action.checked) {
        //If a track is checked, add it to the list
        _schematicSelectedTrackNames.push(action.trackId);
      } else {
        //If the track name is unchecked, remove it from the list
        removeTrack(action.trackId);
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED:
      _showDefaultTracks = action.value;
      _isOverride = action.value;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.RETRIEVED_DEFAULT_TRACKS:
      _defaultTrackNames = action.tracks;

      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.UPDATE_SCHEMATIC_FROM_TEXT:
      //Text that affects the schematic has been updated. Don't use form guids
      _useFormGuids = false;

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_B_REQUEST:
      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _fromMp = action.form.workStartMp;
        _fromMpSfx = action.form.workStartMpSuffix;
        _toMp = action.form.workEndMp;
        _toMpSfx = action.form.workEndMpSuffix;
        action.form.tracks.map(function (t) {
          _schematicSelectedTrackNames.push(t.name);
        });
        if (_form.isPushedFromTss) {
          _useFormGuids = false; //Have to calculate GUIDs if this is a pushed item
        } else {
          _useFormGuids = true;
        }
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.OPEN_FORM_B_RESTRICTION:
      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _fromMp = action.form.workStartMp;
        _fromMpSfx = action.form.workStartMpSuffix;
        _toMp = action.form.workEndMp;
        _toMpSfx = action.form.workEndMpSuffix;
        action.form.tracks.map(function (t) {
          _schematicSelectedTrackNames.push(t.name);
        });
        _useFormGuids = false;
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.OPENING_RESTRICTION:
      _tempStore = null;
      _serverGuidCalculationResult = null;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_A_REQUEST:
      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _trackHasError = false;
        _form = action.form;
        _fromMp = action.form.workStartMp;
        _fromMpSfx = action.form.workStartMpSuffix;
        _toMp = action.form.workEndMp;
        _toMpSfx = action.form.workEndMpSuffix;
        action.form.tracks.map(function (t) {
          _schematicSelectedTrackNames.push(t.name);
        });
        _useFormGuids = true;
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.OPEN_FORM_A_RESTRICTION:
      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _fromMp = action.form.workStartMp;
        _fromMpSfx = action.form.workStartMpSuffix;
        _toMp = action.form.workEndMp;
        _toMpSfx = action.form.workEndMpSuffix;
        action.form.tracks.map(function (t) {
          _schematicSelectedTrackNames.push(t.name);
        });
        _useFormGuids = false;
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.RESET_FORM_B_RESTRICTION:
    case ActionTypes.SUBDIVISION_CHANGED:
    case ActionTypes.POLL_SUCCESSFUL:
    case ActionTypes.REMOVE_POLL_ID:
      //If the form is reset, clear the current selection
      _serverGuidCalculationResult = null;
      _tempStore = null;
      _schematicAvailableTrackNames = [];
      _schematicSelectedTrackNames = [];
      _showDefaultTracks = false;
      _form = null;
      _fromMp = null;
      _fromMpSfx = null;
      _toMp = null;
      _toMpSfx = null;
      _tracksLoading = false;
      _useFormGuids = false;
      _errors = [];
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORM_FIELD_CHANGED:
      if (_fromMp !== null && _toMp !== null)
        _mpEntryChange =
          _fromMp !== action.restriction.workStartMp ||
          _fromMpSfx !== action.restriction.workStartMpSuffix ||
          _toMp !== action.restriction.workEndMp ||
          _toMpSfx !== action.restriction.workEndMpSuffix;
      _fromMp = action.restriction.workStartMp;
      _fromMpSfx = action.restriction.workStartMpSuffix;
      _toMp = action.restriction.workEndMp;
      _toMpSfx = action.restriction.workEndMpSuffix;
      _useFormGuids = false;
      break;

    case ActionTypes.SCHEMATIC_CLICKED:
      if (action.field) {
        if (action.field === "workStartMp") {
          _fromMp = action.mp;
          _fromMpSfx = action.sfx;
        } else {
          _toMp = action.mp;
          _toMpSfx = action.sfx;
        }
      } else if (!_fromMp) {
        _fromMp = action.mp;
        _fromMpSfx = action.sfx;
      } else if (!_toMp) {
        _toMp = action.mp;
        _toMpSfx = action.sfx;
      }

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.RESET_REQUEST_INFO:
      //Check that the form was loaded correctly before trying to open it
      if (action.request) {
        setTimeout(function () {
          dispatcher.dispatch({
            type: ActionTypes.SERVER_CALCULATING_GUIDS,
          });
        }, 1);

        var calc = ServerAPI.calculateTracks(action.request);

        calc
          .done(function success(data) {
            if (data.success) {
              if (!data.data.showDefaultTracks) {
                dispatcher.dispatch({
                  type: ActionTypes.SERVER_CALCULATED_GUIDS,
                  data: data.data,
                });
              } else {
                var msg = "Contact the appropriate dispatcher.";
                if (
                  userStore
                    .getSelectedRole()
                    .indexOf(Constants.Roles.DISPATCHER) > -1
                ) {
                  msg = "Contact the system ACD.";
                }
                dispatcher.dispatch({
                  type: ActionTypes.SERVER_GUID_ERROR,
                  message: "Mps not connected. Override Required. " + msg,
                });
              }
            } else {
              dispatcher.dispatch({
                type: ActionTypes.SERVER_GUID_ERROR,
                message: data.errors[0].message,
              });
            }
          })
          .fail(function () {
            //throw some error
          });

        _form = action.request;
        _fromMp = action.request.workStartMp;
        _fromMpSfx = action.request.workStartMpSuffix;
        _toMp = action.request.workEndMp;
        _toMpSfx = action.request.workEndMpSuffix;
        _form.tracks.map(function (t) {
          _schematicSelectedTrackNames.push(t.name);
        });
        _useFormGuids = true;
        _events.trigger(CHANGE_EVENT);
      }
      break;

    default:
    //no-op
  }
});

export const schematicStore = {
  dispatchToken,
  subscribe: _events.on,
  unsubscribe: _events.off,
  isTrackHasError: () => _trackHasError,
  getServerGuidCalculationResult: () => _serverGuidCalculationResult,
  getSchematicAvailableTracks: () => _schematicAvailableTrackNames,
  getSchematicSelectedTracks: () => _schematicSelectedTrackNames,
  getShowDefaultTracks: () => _showDefaultTracks,
  getTrackData: () => formbScrubber.orderTracks(getAvailableTracks()),
  getDefaultTracks: () => _defaultTrackNames,
  getForm: () => _form,
  getFromMp: () => _fromMp,
  getFromMpSuffix: () => _fromMpSfx,
  getToMp: () => _toMp,
  getToMpSuffix: () => _toMpSfx,
  didMpEntryChange: () => _mpEntryChange,
  getTracksLoading: () => _tracksLoading,
  getErrors: () => _errors,
  getUseFormGuids: () => _useFormGuids,
};
